module.exports = __webpack_public_path__ + "img/shst.f7c2d7cb.png";